import NumberFormat from 'react-currency-format';
import Select from 'react-select';
import moment from 'moment';

import { FormGroup, Input, Label } from "reactstrap";
import { capitalize, map } from "lodash";
import { vehicleTypeList } from "../../../../helper/constants";

const ListingData = ({ onChangeInput, values, isNew, origins = [] }) => (
  <div className='crm-case-form-container'>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="typeVehicle">*Tipo vehiculo:</Label>
        <Input
          className="newArea-select newArea"
          type="select"
          name="typeVehicle"
          id="typeVehicle"
          value={values.typeVehicle}
          disabled={true}
          onChange={onChangeInput('typeVehicle')}
        >
          <option key='select' value=''>
            Seleccione
          </option>
          {map(vehicleTypeList, (e) => (
            <option key={e.id} value={e.value}>
              {e.label}
            </option>
          ))}
        </Input>
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="brand">Marca</Label>
        <Input
          className="newArea"
          name="brand"
          id="brand"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('brand')}
          value={values.brand}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="model">Modelo</Label>
        <Input
          className="newArea"
          name="model"
          id="model"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('model')}
          value={values.model}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="priceVehicle">Precio vehículo:</Label>
        <NumberFormat
          style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
          prefix="$"
          disabled={true}
          min="0"
          name="priceVehicle"
          id="priceVehicle"
          max="99999999"
          className="newArea"
          decimalSeparator=","
          thousandSeparator="."
          value={values.priceVehicle}
          onChange={onChangeInput('priceVehicle')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="initialPayment">Monto Pie:</Label>
        <NumberFormat
          style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
          prefix="$"
          disabled={true}
          min="0"
          name="initialPayment"
          id="initialPayment"
          max="99999999"
          className="newArea"
          decimalSeparator=","
          thousandSeparator="."
          value={values.initialPayment}
          onChange={onChangeInput('initialPayment')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="numberOfFees">Número cuotas:</Label>
        <Input
          type="number"
          name="numberOfFees"
          id="numberOfFees"
          min="0"
          max="99999999"
          className="newArea"
          disabled={true}
          value={values.numberOfFees}
          onChange={onChangeInput('numberOfFees')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="feeToPay">Valor cuota:</Label>
        <NumberFormat
          style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
          prefix="$"
          disabled={true}
          min="0"
          name="feeToPay"
          id="feeToPay"
          max="99999999"
          className="newArea"
          decimalSeparator=","
          thousandSeparator="."
          value={values.feeToPay}
          onChange={onChangeInput('feeToPay')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="year">Año</Label>
        <Input
          type="text"
          name="year"
          id="year"
          maxLength="4"
          className="newArea"
          disabled={true}
          value={values.year}
          onChange={onChangeInput('year')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="origin">*Origen:</Label>
        <Select
          options={map(origins, (e) => ({ label: e.name, value: e.name }))}
          type="text"
          name="origin"
          placeholder="seleccionar"
          id="origin"
          isDisabled={(values.origin) && ((values.origin.value === 'web') ? true : values.editField)}
          value={values.origin}
          onChange={onChangeInput('origin')}
          // isDisabled={optionsOriginphoneFindIt}
          required
        />
      </FormGroup>
    </div>
    {/* <div >
                        <FormGroup>
                          <Label className="label_autofin" for="concessionaire">Concesionario:</Label>
                          <Input
                            className="newArea"
                            name="concessionaire"
                            id="concessionaire"
                            maxLength="40"
                            disabled={true}
                            onChange={onChangeInput('concessionaire')}
                            value={values.concessionaire}
                          />
                        </FormGroup>
                      </div> */}
    <div >
      <FormGroup>
        <Label className="label_autofin" for="dateState">Fecha Estado:</Label>
        <Input
          type="text"
          name="dateState"
          id="dateState"
          maxLength="10"
          className="newArea"
          disabled={true}
          value={values.dateState ? moment(values.dateState).format('DD/MM/YYYY') : ''}
          onChange={onChangeInput('dateState')}
        />
      </FormGroup>
    </div>
    <div >
      <Label className="label_autofin" for="expirationDate">Fecha Primer Vencimiento:</Label>
      <FormGroup>
        <Input
          type="text"
          name="expirationDate"
          id="expirationDate"
          maxLength="10"
          className="newArea"
          disabled={true}
          value={values.expirationDate && moment(values.expirationDate).format('DD/MM/YYYY')}
          onChange={onChangeInput('expirationDate')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="evaluationState">Estado de Solicitud:</Label>
        <Input
          className="newArea"
          name="evaluationState"
          id="evaluationState"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('evaluationState')}
          value={capitalize(values.trinidadStatus)}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="carState">Estado vehículo:</Label>
        <Input
          type="text"
          className="newArea"
          name="carState"
          id="carState"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('carState')}
          value={values.carState}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="term">Plazo:</Label>
        <Input
          className="newArea"
          name="term"
          id="term"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('term')}
          value={values.term}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="cae">CAE:</Label>
        <Input
          className="newArea"
          name="cae"
          id="cae"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('cae')}
          value={values.cae}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="trinidadCode">Código Trinidad:</Label>
        <Input
          className="newArea"
          name="trinidadCode"
          id="trinidadCode"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('trinidadCode')}
          value={values.trinidadCode}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="channelName">Nombre Canal:</Label>
        <Input
          className="newArea"
          name="channelName"
          id="channelName"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('channelName')}
          value={values.channelName}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="dealerName">Nombre Dealer:</Label>
        <Input
          className="newArea"
          name="dealerName"
          id="dealerName"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('dealerName')}
          value={values.dealerName}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="branchName">Nombre Sucursal:</Label>
        <Input
          className="newArea"
          name="branchName"
          id="branchName"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('branchName')}
          value={values.branchName}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="sellerName">Nombre Vendedor:</Label>
        <Input
          className="newArea"
          name="sellerName"
          id="sellerName"
          maxLength="40"
          disabled={true}
          onChange={onChangeInput('sellerName')}
          value={values.sellerName}
        />
      </FormGroup>
    </div>
    {values.isAdmin && (
      <div >
        <FormGroup>
          <Label className="label_autofin" for="executive">*Ejecutivo asignado:</Label>
          <Select
            options={values.users}
            type="text"
            name="executive"
            placeholder="seleccione"
            id="executive"
            isDisabled={!isNew}
            value={values.executive}
            onChange={onChangeInput('executive')}
            required
          />
        </FormGroup>
      </div>
    )}
  </div>
)

export default ListingData;